export default "__VITE_ASSET__d589a1ac__"